import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    continue: 'Continue',
    labels: {
      isResidencyCardValid: 'Is your residency card still valid ?',
      ownedDocumentType: 'Do you have this document ?',
    },
    noResidencyCard: `You don’t have a valid residency card. Send us you **Passport** during the identity verification step.\n\nWe will contact you to get additional information after receiving your application.`,
    options: {
      none: 'No, I don’t have any document',
      residencyCard: 'Yes, I have a residency card',
      visa: 'No, I only have a Visa',
    },
    title: 'Add your residency card',
  },
  fr: {
    continue: 'Continuer',
    labels: {
      isResidencyCardValid:
        'Votre titre de séjour est-il en cours de validité ?',
      ownedDocumentType: 'Êtes-vous en possession de ce document ?',
    },
    noResidencyCard: `Vous n’avez pas de titre de séjour en cours de validité. Transmettez-nous votre **Passeport** durant l’étape de vérification de votre identité.\n\nNous vous contacterons pour plus d’informations après réception de votre dossier.`,
    options: {
      none: 'Non, je n’ai aucun document',
      residencyCard: 'Oui, j’ai un titre de séjour',
      visa: 'Non, j’ai un Visa uniquement',
    },
    title: 'Ajoutez votre titre de séjour',
  },
} as const);
